import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false
})
export class FileUploadComponent {

  @Output() filesChanged = new EventEmitter<File[]>(); // Emit files
  uploadedFiles: File[] = [];

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const filesArray = Array.from(input.files);
      this.uploadedFiles.push(...filesArray);
      this.emitFiles(); // Emit the files whenever they are selected
    }
  }

  removeFile(file: File): void {
    this.uploadedFiles = this.uploadedFiles.filter(f => f !== file);
    this.emitFiles(); // Emit the updated file list after removal
  }

  private emitFiles(): void {
    this.filesChanged.emit(this.uploadedFiles); // Emit the current files array
  }
}
